"use client";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { useStores } from "@packages/store";

import { AuthTitle } from "@/components/AuthTitle";
import { LoginForm, LoginFormData } from "@/components/LoginForm";


const LoginPage = observer(() => {
  const { t } = useTranslation();

  const { auth, error, clearError } = useStores();

  const { login: loginUser } = auth;

  const getError = (error: string) => {
    const errors: Record<string, string> = {
      Unauthorized: t("Login:LoginError"),
    };

    return errors[error] ?? error;
  };

  const handleSubmit = async ({ login, password }: LoginFormData) => {
    clearError();

    const res = await loginUser(login, password);

      if (res) {
        // TODO
        // Тут костыль для перезагрузки страницы потому что router.push не всегда работает корректно
        // Если использовать router.push, то next иногда отдает 307 статус код на запрос домашней страницы
        // Судя по всему редирект происходит в миддлваре, но непонятно почему, куки тут уже должны быть установлены
        setTimeout(() => location.reload(), 500);
    } 
  };

  return (
    <>
      <title>{t("Login:Title")}</title>
      <AuthTitle subtitle={t("Login:Subtitle")} />
      <LoginForm error={getError(error)} onSubmit={handleSubmit} />
    </>
  );
});

export default LoginPage;
